export default __webpack_public_path__ + "static/media/press_room_thumb6.04aa82f4.png";